<script setup lang="ts">
import FlashMessageItem from '@shop/components/ui/FlashMessageItem.vue';
import useFlashStore from '@shop/store/flash';

const flashStore = useFlashStore();
</script>

<template>
  <div v-if="flashStore.messages.length > 0" class="flashmessage__container">
    <div
      v-for="message in flashStore.messages"
      :key="message.id"
      class="flashmessage__item--container"
    >
      <FlashMessageItem
        :id="message.id"
        :level="message.level"
        :message="message.message"
        @dismiss="flashStore.remove"
      />
    </div>
  </div>
</template>
